import React from 'react';

function ProfiiliSection() {
  return (
    <>
      <p>
        Yksi Pulinan keskeisimmistä arvoista on yksityisyyden oikeus. Siksi käyttäjäprofiili ja -asetukset
        mahdollistavat käyttäjän <em>täydellisen määräämisvallan</em> siitä, mitä muut näkevät.
      </p>
    </>
  );
}

export default ProfiiliSection;

